import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../../Components/Buttons/primary-button";

import renderCreditBuilderLearnMore from "../../Organisms/Modals/Credit-Builder/learn-more";
import renderCreditBuilderOptIn from "../../Organisms/Modals/Credit-Builder/credit-builder-opt-in";
import renderCreditBuilderOptOut from "../../Organisms/Modals/Credit-Builder/credit-builder-opt-out";

import { useModalContext } from "../../Contexts/ModalContext";

import { CreditBuilderCoin, CreditBuilderSparkle } from "../../Assets/Images";

export default function OptCreditBuilder({ hasInactiveStakeSaverOffer, optedIn }) {
  const navigate = useNavigate();
  const modalContext = useModalContext();

  const handleOpenCreditBuilder = useCallback(() => {
    if (hasInactiveStakeSaverOffer) {
      navigate("/deals/stake-saver");
    } else if (optedIn) {
      renderCreditBuilderOptOut(modalContext);
    } else {
      renderCreditBuilderOptIn(modalContext);
    }
  }, [navigate, modalContext, hasInactiveStakeSaverOffer, optedIn]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get("openCreditBuilder") === "true") {
      handleOpenCreditBuilder();
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [handleOpenCreditBuilder]);
  return (
    <div className="credit-builder-setting">
      <img className="coin" src={CreditBuilderCoin} alt=""></img>
      <img className="sparkle" src={CreditBuilderSparkle} alt=""></img>
      <div className="section-header mb-sm-6 mb-4">
        <div className="section-content">
          <div className="section-title">Credit Builder</div>
          <div className="section-description">
            Stake only reports on-time rent payments that help build your credit.{" "}
            <button className="color--primary-400" onClick={renderCreditBuilderLearnMore.bind(this, modalContext)}>
              Learn more.
            </button>
          </div>
        </div>
      </div>
      <PrimaryButton onClick={handleOpenCreditBuilder}>
        {hasInactiveStakeSaverOffer ? "Join Stake Saver" : optedIn ? "Edit my preferences" : "Start"}
      </PrimaryButton>
    </div>
  );
}
